import { put, takeLatest } from 'redux-saga/effects';
import { authenticatedCall } from '../../utils/authenticated-call';
import { uploadCsvAPI } from '../../api/provider/booking/booking-provider';
import { uploadCsvAction, uploadCsvErrorAction, uploadCsvSuccessAction } from '../../store/customers/upload-csv.store';


function* uploadCsvSaga(data: any) {

  const dataToSend = new FormData()

  if (data.payload.file_csv instanceof File) {
    dataToSend.append('file_csv', data.payload.file_csv)
  }
  delete data.payload.file_csv

  dataToSend.append('interval', data.payload.interval)

  try {
    yield authenticatedCall(uploadCsvAPI, dataToSend);
    yield put(uploadCsvSuccessAction())
  } catch (error: any) {
    yield put(uploadCsvErrorAction(error.localizedMessage));
  }
}


export function* uploadCsvSagas() {
  yield takeLatest(uploadCsvAction.type, uploadCsvSaga);
}
